/**
 * ANQ.UserProfile.API 
 * User Profile Service
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface TenantCreateRequestDto { 
    name: string;
    ownerId: number;
    active?: boolean;
    createdBy: number;
    contactPersonFirstName: string;
    contactPersonLastName: string;
    contactPersonEmail: string;
    phoneNumber?: string;
    contactPersonPhoneNumber?: string;
    applicationId?: number;
}